import React from 'react';
import { Button, Card, Select, Space, Typography } from 'antd';
import { CheckOutlined, ClockCircleOutlined, StopOutlined } from '@ant-design/icons';

const { Paragraph } = Typography;

const statusOptions = [
    { value: 'not_started', label: 'Not started' },
    { value: 'in_progress', label: 'In progress' },
    { value: 'pending_approval', label: 'Pending approval' },
    { value: 'completed', label: 'Completed' },
    { value: 'cancelled', label: 'Cancelled' },
];

export default function OnboardingManagerActions({ status, updating, onStatusChange, onSaveStatus, onOpenUpload }) {
    return (
        <Card className="onboarding-panel onboarding-accent-panel" title="Manager Controls">
            <Space direction="vertical" size={14} style={{ width: '100%' }}>
                <Paragraph style={{ marginBottom: 0 }}>
                    Keep the overall onboarding status explicit so employees and managers are looking at the same signal.
                </Paragraph>
                <Select
                    value={status}
                    options={statusOptions}
                    onChange={onStatusChange}
                />
                <Space wrap>
                    <Button type="primary" loading={updating} icon={<CheckOutlined />} onClick={onSaveStatus}>
                        Save status
                    </Button>
                    <Button icon={<ClockCircleOutlined />} onClick={onOpenUpload}>
                        Upload document
                    </Button>
                    <Button danger ghost icon={<StopOutlined />} onClick={() => onStatusChange('cancelled')}>
                        Mark cancelled
                    </Button>
                </Space>
            </Space>
        </Card>
    );
}
